// FAQ data for SwiftFixPro Property Maintenance Service
export const faqCategories = [
  {
    id: 'general',
    title: 'General Services',
    icon: '🏠',
    faqs: [
      {
        id: 'what-is-swift-fix-pro',
        question: 'What is SwiftFixPro?',
        answer: 'SwiftFixPro is Singapore\'s premier property maintenance and repair service platform. We connect property owners with verified, trusted service providers for all types of home and commercial property maintenance needs, from plumbing and electrical work to aircon servicing and renovation projects.'
      },
      {
        id: 'service-areas',
        question: 'Which areas in Singapore do you serve?',
        answer: 'We provide services across all areas of Singapore including Central Singapore, Ang Mo Kio, Bedok, Bishan, Bukit Batok, Bukit Merah, Bukit Panjang, Bukit Timah, Choa Chu Kang, Clementi, Geylang, Hougang, Jurong East, Jurong West, Kallang, Marine Parade, Novena, Pasir Ris, Punggol, Queenstown, Sembawang, Sengkang, Serangoon, Tampines, Toa Payoh, Woodlands, and Yishun.'
      },
      {
        id: 'how-to-book',
        question: 'How do I book a service?',
        answer: 'Booking is simple! Create an account, browse our services, select what you need, choose a time slot that works for you, and confirm your booking. You\'ll receive instant confirmation and can track your service provider in real-time.'
      },
      {
        id: 'service-guarantee',
        question: 'Do you provide service guarantees?',
        answer: 'Yes! We offer a comprehensive service guarantee. All our service providers are vetted and insured. If you\'re not satisfied with the work, we\'ll make it right with free re-service or full refund within 30 days.'
      },
      {
        id: 'emergency-services',
        question: 'Do you provide emergency services?',
        answer: 'Absolutely! We offer 24/7 emergency services for urgent issues like water leaks, electrical problems, aircon breakdowns, and security concerns. Emergency services are available with premium rates and faster response times.'
      },
      {
        id: 'pricing-transparency',
        question: 'How transparent is your pricing?',
        answer: 'We believe in complete pricing transparency. You\'ll see upfront costs before booking, with no hidden fees. Our service providers provide detailed quotes, and you only pay after satisfactory completion of work.'
      }
    ]
  },
  {
    id: 'account',
    title: 'Account & Registration',
    icon: '👤',
    faqs: [
      {
        id: 'create-account',
        question: 'How do I create an account?',
        answer: 'Creating an account is easy! Click "Register" and choose between Customer or Agent registration. Fill in your personal details, contact information, and create a secure password. For customers, you can also enter a referral code if you have one.'
      },
      {
        id: 'account-types',
        question: 'What are the different account types?',
        answer: 'We offer two main account types: Customer accounts for property owners who need services, and Agent accounts for property agents who want to refer clients and earn commissions. Each account type has specific features tailored to your needs.'
      },
      {
        id: 'forgot-password',
        question: 'What if I forget my password?',
        answer: 'No worries! Click "Forgot Password" on the login page, enter your email address, and we\'ll send you a secure reset link. Follow the instructions in the email to create a new password.'
      },
      {
        id: 'update-profile',
        question: 'Can I update my profile information?',
        answer: 'Yes, you can update your profile anytime through your dashboard. Go to Account Settings to modify your personal information, contact details, and preferences. Some changes may require verification for security purposes.'
      },
      {
        id: 'account-security',
        question: 'How secure is my account?',
        answer: 'Your account security is our priority. We use industry-standard encryption, secure authentication, and optional two-factor authentication. Your payment information is never stored and all transactions are processed through secure, PCI-compliant payment gateways.'
      },
      {
        id: 'how-to-delete-my-account',
        question: 'How to delete my account?',
        answer: 'You can delete your account from the profile page'
      }
    ]
  },
  {
    id: 'agent-program',
    title: 'Agent Referral Program',
    icon: '🤝',
    faqs: [
      {
        id: 'agent-program-overview',
        question: 'What is the Agent Referral Program?',
        answer: 'Our Agent Referral Program allows property agents to earn 15% commission on every successful client referral. It\'s designed specifically for licensed property agents who want to provide additional value to their clients while earning extra income.'
      },
      {
        id: 'agent-eligibility',
        question: 'Who can become a referral agent?',
        answer: 'Only licensed property agents registered with the Council for Estate Agencies (CEA) in Singapore are eligible. You must provide a valid CEA registration number during registration, which we verify through the CEA Public Register.'
      },
      {
        id: 'cea-requirement',
        question: 'Why do I need a CEA registration?',
        answer: 'CEA registration ensures that only legitimate, licensed property professionals participate in our program. This maintains the integrity of our referral network and complies with Singapore\'s property industry regulations.'
      },
      {
        id: 'commission-structure',
        question: 'How does the commission structure work?',
        answer: 'Agents earn 15% commission on the total service value of successful referrals. Commissions are calculated after service completion and customer payment. We also offer a tier progression system from Bronze to Platinum based on performance.'
      },
      {
        id: 'commission-payment',
        question: 'When and how do I get paid?',
        answer: 'Commissions are paid monthly via bank transfer. You can track your earnings in real-time through your agent dashboard, which shows pending commissions, completed payments, and detailed referral history.'
      },
      {
        id: 'referral-tracking',
        question: 'How are referrals tracked?',
        answer: 'Each agent receives a unique referral code. When clients use your code during registration or booking, the referral is automatically tracked in our system. You can monitor all your referrals and their status in your dashboard.'
      }
    ]
  },
  {
    id: 'cea-verification',
    title: 'CEA Verification Process',
    icon: '🛡️',
    faqs: [
      {
        id: 'cea-verification-process',
        question: 'How does CEA verification work?',
        answer: 'After you register with your CEA number, our admin team manually verifies your registration through the CEA Public Register. This process typically takes 1-3 business days. You\'ll receive an email notification once verification is complete.'
      },
      {
        id: 'cea-number-format',
        question: 'What format should my CEA registration number be in?',
        answer: 'CEA registration numbers typically follow formats like R123456A or RB123456. Enter your number exactly as it appears on your CEA license. Our system will automatically format it to uppercase for consistency.'
      },
      {
        id: 'verification-pending',
        question: 'What can I do while verification is pending?',
        answer: 'While your CEA verification is pending, you can complete your profile setup and familiarize yourself with the agent dashboard. However, you won\'t be able to generate referral codes or earn commissions until verification is approved.'
      },
      {
        id: 'verification-rejected',
        question: 'What if my CEA verification is rejected?',
        answer: 'If verification fails, you\'ll receive an email with the specific reason. Common issues include expired licenses, incorrect registration numbers, or name mismatches. You can update your information and request re-verification.'
      },
      {
        id: 'cea-renewal',
        question: 'What happens when my CEA license expires?',
        answer: 'We monitor CEA license expiry dates. Before your license expires, you\'ll receive renewal reminders. Once expired, your agent status will be temporarily suspended until you provide updated license information.'
      },
      {
        id: 'manual-verification',
        question: 'Why is verification done manually?',
        answer: 'CEA doesn\'t provide a public API for automated verification. Our admin team manually checks each registration against the official CEA Public Register to ensure accuracy and prevent fraud.'
      }
    ]
  },
  {
    id: 'privacy-cookies',
    title: 'Privacy & Cookies',
    icon: '🍪',
    faqs: [
      {
        id: 'cookie-usage',
        question: 'How do you use cookies?',
        answer: 'We use cookies to enhance your experience with features like remembering your login, saving form progress, and providing personalized content. We categorize cookies into Essential, Preferences, Analytics, and Marketing, giving you full control over your choices.'
      },
      {
        id: 'cookie-consent',
        question: 'Can I control cookie settings?',
        answer: 'Absolutely! You have full control over cookie preferences. You can accept all, reject non-essential cookies, or customize which categories you want to allow. You can change these settings anytime through the cookie banner or privacy settings.'
      },
      {
        id: 'data-collection',
        question: 'What personal data do you collect?',
        answer: 'We collect only necessary information: contact details for service delivery, payment information for transactions, and usage data to improve our services. For agents, we also collect CEA registration details for verification purposes.'
      },
      {
        id: 'data-security',
        question: 'How is my data protected?',
        answer: 'We use industry-standard security measures including encryption, secure servers, and regular security audits. Your payment information is processed through PCI-compliant gateways and never stored on our servers.'
      },
      {
        id: 'data-sharing',
        question: 'Do you share my data with third parties?',
        answer: 'We only share data when necessary for service delivery (e.g., with service providers for job completion) or as required by law. We never sell your personal information to third parties for marketing purposes.'
      },
      {
        id: 'gdpr-rights',
        question: 'What are my privacy rights?',
        answer: 'You have the right to access, correct, delete, or export your personal data. You can also object to processing or request data portability. Contact our privacy team to exercise these rights or if you have privacy concerns.'
      }
    ]
  },
  {
    id: 'payments',
    title: 'Payments & Billing',
    icon: '💳',
    faqs: [
      {
        id: 'payment-methods',
        question: 'What payment methods do you accept?',
        answer: 'All payments are processed securely through HitPay. HitPay supports credit/debit cards (Visa, MasterCard, American Express), PayNow, online banking, and digital wallets. All transactions are encrypted and PCI-compliant for your security.'
      },
      {
        id: 'payment-timing',
        question: 'When do I pay for services?',
        answer: 'Payment is due after service completion and your satisfaction confirmation. You\'ll receive a detailed invoice via email and can pay through your dashboard or the payment link provided.'
      },
      {
        id: 'refund-policy',
        question: 'What is your refund policy?',
        answer: 'We offer full refunds for cancelled bookings (with appropriate notice) and unsatisfactory services. If you\'re not happy with the work, we\'ll first attempt to resolve the issue with free re-service. If that\'s not possible, we provide full refunds within 30 days.'
      },
      {
        id: 'invoice-receipt',
        question: 'Can I get invoices and receipts?',
        answer: 'Yes! You\'ll automatically receive detailed invoices and receipts via email for all transactions. You can also download them from your dashboard anytime. All invoices include GST where applicable.'
      },
      {
        id: 'payment-security',
        question: 'How secure are my payments?',
        answer: 'Payment security is our top priority. We use 256-bit SSL encryption, PCI DSS compliant processors, and never store your payment information. All transactions are monitored for fraud protection.'
      }
    ]
  },
  {
    id: 'technical',
    title: 'Technical Support',
    icon: '🔧',
    faqs: [
      {
        id: 'system-requirements',
        question: 'What are the system requirements?',
        answer: 'Our platform works on all modern browsers (Chrome, Firefox, Safari, Edge) on desktop, tablet, and mobile devices. For the best experience, ensure your browser is updated to the latest version and JavaScript is enabled.'
      },
      {
        id: 'mobile-app',
        question: 'Do you have a mobile app?',
        answer: 'Currently, we offer a responsive web platform that works perfectly on mobile browsers. A dedicated mobile app is in development and will be available soon for both iOS and Android devices.'
      },
      {
        id: 'browser-issues',
        question: 'I\'m experiencing technical issues. What should I do?',
        answer: 'First, try refreshing the page or clearing your browser cache. If issues persist, try using a different browser or incognito mode. For ongoing problems, contact our technical support team with details about your device and browser.'
      },
      {
        id: 'account-access-issues',
        question: 'I can\'t access my account. What should I do?',
        answer: 'Check if you\'re using the correct email and password. Try the "Forgot Password" option if needed. Clear your browser cache and cookies, or try accessing from a different device. If problems continue, contact our support team.'
      },
      {
        id: 'feature-requests',
        question: 'Can I suggest new features?',
        answer: 'Absolutely! We value user feedback and continuously improve our platform. You can submit feature requests through the feedback form in your dashboard or contact our support team with your suggestions.'
      }
    ]
  },
  {
    id: 'contact-support',
    title: 'Contact & Support',
    icon: '📞',
    faqs: [
      {
        id: 'contact-methods',
        question: 'How can I contact customer support?',
        answer: 'You can reach us through multiple channels: 24/7 live chat on our website, email at support@swiftfixpro.sg, phone at +65 6XXX XXXX, or through the contact form in your dashboard. We typically respond within 2 hours during business hours.'
      },
      {
        id: 'support-hours',
        question: 'What are your support hours?',
        answer: 'Our customer support team is available 24/7 for emergencies. For general inquiries, our main support hours are Monday to Friday, 8 AM to 8 PM, and weekends 9 AM to 6 PM Singapore time.'
      },
      {
        id: 'emergency-contact',
        question: 'How do I reach you in an emergency?',
        answer: 'For urgent property emergencies (water leaks, electrical issues, security concerns), call our 24/7 emergency hotline at +65 6XXX XXXX or use the "Emergency Service" button in your dashboard for immediate assistance.'
      },
      {
        id: 'feedback-complaints',
        question: 'How do I provide feedback or file a complaint?',
        answer: 'We welcome all feedback! You can provide feedback through your dashboard after each service, email us at feedback@swiftfixpro.sg, or use the feedback form on our website. For complaints, we have a dedicated resolution process to address your concerns quickly.'
      },
      {
        id: 'business-inquiries',
        question: 'I have a business inquiry. Who should I contact?',
        answer: 'For business partnerships, bulk service contracts, or corporate accounts, contact our business development team at business@swiftfixpro.sg or call +65 6XXX XXXX extension 2. We offer special rates for property management companies and large-scale projects.'
      }
    ]
  }
];
